import { useEffect, useState } from 'react';

import { RootState, store } from '../store';
import { IGantState } from '../store/slices/gantSlice';

let gantState: IGantState;
let isSet = false;

export const useSettingsOnce = () => {
    const selector = (state: RootState) => state.gant;

    const [refresh, setRefresh] = useState(0);
    if (!gantState) {
        gantState = store.getState().gant;
    }

    useEffect(() => {
        if (isSet) {
            return;
        }
        const checkForUpdates = () => {
            const newState = selector(store.getState());

            if (newState.settingGant) {
                gantState = { ...newState };
                setRefresh(refresh + 1);
                isSet = true;
                unsubscribe();
            }
        };

        const unsubscribe = store.subscribe(checkForUpdates);

        return () => unsubscribe();
    }, []);

    return gantState;
};
